import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

function ImpactNumbers() {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div className="bg-[#0c2340] text-white py-10">
      <div className=" mx-auto px-4 sm:px-6 lg:px-20">
        <h2 className="text-3xl sm:text-3xl lg:text-4xl font-bold uppercase text-left sm:text-left md:ml-44">
          Driven by Results:
        </h2>
        <h3 className="text-3xl sm:text-3xl lg:text-4xl font-bold mb-8 text-left sm:text-left md:ml-44">
          OUR IMPACT IN NUMBERS
        </h3>

        <div ref={ref} className="grid grid-cols-1 gap-8">
          {/* Row 1 */}
          <div className="flex flex-col md:flex-row items-center border-b border-gray-500 border-t pb-6">
            <div className="w-full md:w-1/3 text-left md:text-center">
              <span className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-50">
                {inView && <CountUp end={1000} duration={8} />}+<br />
                <span className="text-base sm:text-lg lg:text-xl">CLIENTS</span>
              </span>
            </div>
            <div className="w-full md:w-2/3 hover:scale-105 duration-300 ease-in-out mt-4 md:mt-0 text-left md:text-left">
              <h4 className="text-lg sm:text-xl lg:text-3xl font-semibold">
                Trusted by Clients Worldwide
              </h4>
              <p className="text-gray-300">
                We are proud to be the trusted partner of clients across the globe.
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className="flex flex-col md:flex-row items-center border-b border-gray-500 pb-6">
            <div className="w-full md:w-1/3 text-left md:text-center">
              <span className="text-3xl sm:text-4xl lg:text-5xl font-bold  text-gray-50">
                {inView && <CountUp end={15000} duration={8} />}+<br />
                <span className="text-base sm:text-lg lg:text-xl">PROJECTS</span>
              </span>
            </div>
            <div className="w-full md:w-2/3 hover:scale-105 duration-300 ease-in-out mt-4 md:mt-0 text-left md:text-left">
              <h4 className="text-lg sm:text-xl lg:text-3xl font-semibold">
                Proven Track Record of Successful Projects
              </h4>
              <p className="text-gray-300">
                With a history of completed projects, we deliver results across various industries.
              </p>
            </div>
          </div>

          {/* Row 3 */}
          <div className="flex flex-col md:flex-row items-center border-b border-gray-500 pb-6">
            <div className="w-full md:w-1/3 text-left md:text-center">
              <span className="text-3xl sm:text-4xl lg:text-5xl font-bold  text-gray-50">
                {inView && <CountUp end={20} duration={10} />}+<br />
                <span className="text-base sm:text-lg lg:text-xl">COUNTRIES</span>
              </span>
            </div>
            <div className="w-full md:w-2/3 hover:scale-105 duration-300 ease-in-out mt-4 md:mt-0 text-left md:text-left">
              <h4 className="text-lg sm:text-xl lg:text-3xl font-semibold">
                Global Presence and Reach
              </h4>
              <p className="text-gray-300">
                Our solutions are trusted by clients in countries worldwide, making a global impact.
              </p>
            </div>
          </div>

          {/* Row 4 */}
          <div className="flex flex-col md:flex-row items-left border-b border-gray-500 pb-6">
            <div className="w-full md:w-1/3 text-left md:text-center">
              <span className="text-3xl sm:text-4xl lg:text-5xl font-bold  text-gray-50">
                {inView && <CountUp end={100} duration={8} />}%<br />
                <span className="text-base sm:text-lg lg:text-xl">SATISFACTION RATE</span>
              </span>
            </div>
            <div className="w-full md:w-2/3 hover:scale-105 duration-300 ease-in-out mt-4 md:mt-0 text-left md:text-left">
              <h4 className="text-lg sm:text-xl lg:text-3xl font-semibold">
                Commitment to Client Satisfaction
              </h4>
              <p className="text-gray-300">
                We maintain a 100% satisfaction rate by providing exceptional service and high-quality solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImpactNumbers;
